import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Video } from 'components/ui';
import { useSelector } from 'hooks';
import { getKioskVideoGuide } from 'modules/dealers/selectors';
import { MediaType } from 'types/AbstractMedia';


const QrCodeVideo = () =>{
  const videoGuide = useSelector(getKioskVideoGuide);

  return (
    videoGuide && (
      <div className="kioskSharebox:flex-1 kioskSharebox:order-first">
        <div className="w-full border-t border-separator my-4xl kioskSharebox:hidden" />
        <div className="relative rounded-card overflow-hidden">
          <Video
            loop
            muted
            autoPlay
            controls={false}
            media={{
              path: videoGuide,
              type: MediaType.VIDEO,
            }}
          />
          <div className="font-s text-inverse w-full p-10 absolute bottom-0">
            <FormattedMessage
              id="login.qrCodeVideo"
              defaultMessage="If you have a QR code, you can scan it using the kiosk’s QR code reader to quickly access your appointment."
            />
          </div>
        </div>
      </div>
    ));
};

export default QrCodeVideo;